import type { User } from "@/types";

type CompromisedPasswordBannerUser = Pick<
  User,
  "id" | "is_pwned" | "pwned_banner_dismissed"
>;

export const shouldShowCompromisedPasswordBanner = (
  user?: CompromisedPasswordBannerUser,
) =>
  Boolean(user?.id && user.is_pwned && !user.pwned_banner_dismissed);
